import React from 'react'
import {Divider, Steps, Row, Col, Input, Select, Checkbox, DatePicker,
    Button, Table, Pagination, TreeSelect, Tooltip, message,
    BackTop, Spin, Tabs, Modal} from 'antd'
import common from '@/public/common'
import './list.less'
import { withRouter } from 'react-router-dom'
import {ajaxApi, ajaxApiGet, getMethod, submitMethod} from '@/server'
import { summation, getCookie, getCookieNew, getParmUrl, outputMoney } from '../../public/utils'
import DateChoose from '../../compenents/dateChoose'
import moment from 'moment'
const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const { TextArea } =Input
const urlLink = common.SapUrl

class AddSend extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
          visible: false,
          sping: false,
          sendId: '',
          logis: [],
          sendList: [],
          selectedRowKeys: [],
          rows: [],
          reconciliation_code: '',
          chooseData: [],
          addInfo: {},
          key: '1',
          pageSize: 15,
          pageNo: 1,
          current: 1
        }
    }
    componentDidMount () {
        this.getCompany()
        if (getParmUrl('code')) {
            this.getDetails()
        }
    }
    getScode = () => {
        return getCookie("supplierinfo")
          ? JSON.parse(getCookie("supplierinfo")).code
          : null;
      };
      getSName = () => {
          return getCookie("supplierinfo")
            ? JSON.parse(getCookie("supplierinfo")).real_name
            : null;
        };
    // 编辑单据查详情
    getDetails = () => {
      this.setState({
          sping: true
      }, () => {
        let param = {
            code: getParmUrl('code')
        }
        getMethod(urlLink + '/document/query-detail/'+ getParmUrl('code')).then(res => {
           if (res.data) {
               let _info = {
                   type: res.data.type,
                   sender: res.data.sender,
                   send_date: res.data.send_date,
                   logistics_name: res.data.logistics_name,
                   logistics_code: res.data.logistics_code,
                   remark: res.data.remark,
                   document_code: res.data.document_code
               }
               this.setState({
                   addInfo: _info,
                   sendList: res.data.reconciliation_codes,
                   sendId: res.data.id,
                   sping: false
               })
           }
        })
      })
    }
    // 获取对账单详情
    getSend = () => {
        let param = {
            scs: true,
            state: 'document',
            name: this.getScode(),
            reconciliation_code: this.state.reconciliation_code,
            page_no: this.state.pageNo,
            page_size: this.state.pageSize
        }
        ajaxApi({
            url: urlLink + 'reconciliation/query-list',
            params: param
        }).then((res) => {
           if (res.data) {
               this.setState({
                  chooseData: res.data.data
               })
           }
        })
    }
    getCompany = () => {
        ajaxApiGet({
            url: urlLink + '/document/express   ',
            params: {}
        }).then((res) => {
            if (res) {
                this.setState({
                    logis: res.data
                })
            }
        })
    }
    // 输入框取值
    onChangeInput = (name, val) => {
        let _info = this.state.addInfo
        _info[name] = val.target.value
        this.setState({
            addInfo: _info
        })
      }
    //下拉框取值
    onChangeSelect = (name, value, labelValue) => {
      console.log(name, value, labelValue)
      let _info = this.state.addInfo
      _info[name] = labelValue.props.value
      if (name === 'logistics') {
          _info.logistics_name = labelValue.props.children
      }
      this.setState({
          addInfo: _info
      })
    }
    // 特殊下拉款
    selectChange = (val) => {
        let _arr = val
        this.setState({
            sendList: _arr
        })
    }
    // 寄件日期取值
    onChangeTime = (val) => {
        let _info = this.state.addInfo
        _info.send_date = new Date(val).getTime()
        this.setState({
            addInfo: _info
        })

    }
    // 选择对账单搜索框取值
    seachInput = (val) => {
      this.setState({
        reconciliation_code: val.target.value
      })
    }
    // 对账单搜索
    search = () => {
        this.getSend()
    }
    // 选择对账单全部/已选择
    callback = (key) => {
       this.setState({
           key: key
       })
    }
    // 选择对账单
    addList = () => {
        this.setState({
            visible: true
        }, () => {
            this.getSend()
        })
    }
    // 选择对账单确认
    handelOk = () => {
        if (this.state.rows.length > 0) {
            let _arr = this.state.rows.map(item => {
                return item.reconciliation_code
            })
            this.setState({
                sendList: _arr,
                visible: false,
                rows: [],
                selectedRowKeys: [],
            })
        } else {
            message.info('您还没有选择任何项！')
        }
    }
    // 选择最账单取消
    handelCancel = () => {
        this.setState({
            visible: false,
            rows: [],
            selectedRowKeys: [],
        })
    }
    // 新增寄送单提交/保存
    save = (type) => {
        let _info = this.state.addInfo
        if (!_info.type) {
            message.error('单据类型必填！')
            return false
        }
        if (!_info.sender) {
          message.error('寄件人必填！')
          return false
      }
      if (!_info.send_date) {
          message.error('寄件日期必填！')
          return false
      }
      if (this.state.sendList.length < 1) {
          message.error('对账单必填！')
          return false
      }
      if (!_info.logistics_name) {
          message.error('快递公司必填！')
          return false
      }
      if (!_info.logistics_code) {
          message.error('快递单号必填！')
          return false
      }
      let param = {}
      if (type === 'save') {
        param = {
            ..._info,
            id: getParmUrl('code') ? this.state.sendId : 0,
            reconciliation_codes: this.state.sendList,
            supplierName: this.getSName(),
            supplierCode: this.getScode(),
            status: 'waitSubmit'
        }
      } else {
        param = {
            ..._info,
            id: getParmUrl('code') ? this.state.sendId : 0,
            reconciliation_codes: this.state.sendList,
            supplierName: this.getSName(),
            supplierCode: this.getScode(),
            status: 'waitSign'
        }
      }
      this.setState({
          sping: true
      }, () => {
        ajaxApi({
            url: urlLink + '/document/dispose',
            params: param
          }).then((res) => {
            if (res) {
                if (type === 'save') {
                    message.success('保存成功！')
                    this.props.history.push('/main/supplierRecantion/sendList')
                } else {
                    message.success('提交成功！')
                    this.props.history.push('/main/supplierRecantion/sendList')
                }
                this.setState({
                    sping: false
                })
            }
          })
      })
    }
     // 选择对账单表格分页
     pageOnChange = (val) => {
        this.setState({
            current: val,
            pageNo: val,
        }, () => {
            this.getSend()
        })
      }
    sizeOnchange = (current, size) => {
        this.setState({
            current: current,
            pageNo: current,
            pageSize: size
        }, () => {
              this.getSend()
        })
    }
    // 取消操作
    cancelChange=()=>{
        this.props.history.push('/main/supplierRecantion/sendList')
    }
    render () {
        const { visible, selectedRowKeys, rows, key, chooseData } = this.state
        const columns = [
            {
                title: '对账单号',
                width: 120,
                dataIndex: 'reconciliation_code'
            },
            {
                title: '账期',
                width: 180,
                dataIndex: 'term',
                render: (text, record) => (
                    <span>{ record.reconciliation_begin_time ? moment(record.reconciliation_begin_time).format('YYYY-MM-DD') + '~' + moment(record.reconciliation_end_time).format('YYYY-MM-DD') : ''}</span>
                )
            },
            {
                title: '编码',
                width: 80,
                dataIndex: 'supplier_code'
            },
            {
                title: '供应商名称',
                width: 150,
                dataIndex: 'supplier_name'
            },
            {
                title: '状态',
                width: 100,
                dataIndex: 'type'
            },
            {
                title: '应付金额',
                width: 120,
                dataIndex: 'payable_amount',
                align: 'right',
                render: (text) => (
                    <span>{outputMoney(text)}</span>
                )
            },
            {
                title: '应收金额',
                width: 120,
                dataIndex: 'receivable_amount',
                align: 'right',
                render: (text) => (
                    <span>{outputMoney(text)}</span>
                )
            },
            {
                title: '出账时间',
                width: 120,
                dataIndex: 'charge_off_time',
                render: (text) => (
                    <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
                )
            },
            {
                title: '备注',
                width: 120,
                dataIndex: 'remark'
            },

        ]
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    rows: selectedRows,
                    selectedRowKeys: selectedRowKeys
                })
              },
              onSelect: (record, selected, selectedRows) => {
                // console.log(record, selected, selectedRows);
              },
              onSelectAll: (selected, selectedRows, changeRows) => {
                // console.log(selected, selectedRows, changeRows);
              },
          }
        return (
            <div className="addSend">
                <Spin spinning={this.state.sping}>
                <h1>{getParmUrl('code') ? '修改寄送单（单号：'+ getParmUrl('code') +'）' : '新增寄送单'}</h1>
                <Divider/>
                <div className="sendDetails">
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>寄送单号：</label>
                            <span>保存后自动生成</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>文件类型：</label>
                            <Select placeholder="请选择" onSelect={this.onChangeSelect.bind(this, 'type')} value={this.state.addInfo.type}>
                                <Option value="A">对账单</Option>
                                <Option value="B">发票</Option>
                                <Option value='C'>对账单和发票</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>寄件人：</label>
                            <Input placeholder="请输入" onChange={this.onChangeInput.bind(this, 'sender')} value={this.state.addInfo.sender}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>寄件日期：</label>
                            <DatePicker onChange={this.onChangeTime} value={this.state.addInfo.send_date ? moment(this.state.addInfo.send_date) : ''}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>对账单：</label>
                            <span onClick={this.addList}>
                            <Select placeholder='请选择' mode="tags" open={false} value={this.state.sendList} onChange={this.selectChange}></Select>
                            </span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>供应商代码：</label>
                            <span>{this.getScode()}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>供应商名称：</label>
                            <span>{this.getSName()}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>快递公司：</label>
                            <Select placeholder="请选择" onSelect={this.onChangeSelect.bind(this, 'logistics')} value={this.state.addInfo.logistics_name}>
                                {
                                  this.state.logis.map(item => {
                                  return <Option value={item.code} key={item.code}>{item.name}</Option>
                                  })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>快递单号：</label>
                            <Input placeholder="请输入" onChange={this.onChangeInput.bind(this, 'logistics_code')} value={this.state.addInfo.logistics_code}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label style={{float: 'left'}}>备注：</label>
                            <TextArea row={2} placeholder="请输入备注" onChange={this.onChangeInput.bind(this, 'remark')} value={this.state.addInfo.remark}/>
                        </Col>
                    </Row>
                </div>
                <div className="button">
                    <Button type="primary" style={{marginRight: '20px'}} onClick={this.save.bind(this, 'save')} shape="round">保存草稿</Button>
                    {getParmUrl('code')? <Button type="primary" style={{marginRight: '20px'}} onClick={this.save.bind(this, 'submit')} shape="round">提交视客</Button>:null}
                    <Button style={{marginRight: '20px'}} onClick={this.cancelChange} shape="round">取消</Button>
                </div>
                <Modal title="选择对账单"
                       visible={visible}
                       width={1200}
                       className="sendModal"
                       footer={[<Button type="primary" onClick={this.handelOk} shape="round">确认</Button>,<Button onClick={this.handelCancel} shape="round">取消</Button>]}
                       onCancel={this.handelCancel}>
                           <Row style={{marginBottom: '20px'}}>
                               <Col span={16}>
                                   <label>对账单：</label>
                                   <Input placeholder="请输入对账单号" style={{width: '50%'}} onChange={this.seachInput}/>
                                   <Button type="primary" style={{marginLeft: '10px'}} onClick={this.search} shape="round">查询</Button>
                               </Col>
                           </Row>
                           <Tabs onChange={this.callback}>
                               <TabPane tab="全部" key={1}></TabPane>
                               <TabPane tab="已选择" key={2}></TabPane>
                           </Tabs>
                           <Table columns={columns} dataSource={ key === '1' ? chooseData : rows} rowSelection={rowSelection} pagination={false} rowKey={(record, index) => record.id}/>
                           <div className="pagination" style={{textAlign: 'right',position: 'relative',marginTop: '20px'}}>
                                <span className="datanum" style={{position: "absolute",left: '0',top: '5px'}}>共{key === '1' ? chooseData.length : rows.length}条数据</span>
                                <Pagination showQuickJumper showSizeChanger current={this.state.current} total={key === '1' ? chooseData.length : rows.length} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                           </div>
                       </Modal>
                </Spin>
            </div>
        )
    }

}
export default AddSend



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/addSend.js